/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Utils = window.OletLens.Utils || {};

  function getFormData() {
    var personNameInput = document.getElementById('person_name');
    var commentsInput = document.getElementById('comments');

    var od = {
      sph: parseFloat((document.getElementById('od_sph') || {}).value) || 0,
      cyl: parseFloat((document.getElementById('od_cyl') || {}).value) || 0,
      axis: parseFloat((document.getElementById('od_axis') || {}).value) || 0,
      add: (document.getElementById('od_add') || {}).value || 'n/a',
    };

    var os = {
      sph: parseFloat((document.getElementById('os_sph') || {}).value) || 0,
      cyl: parseFloat((document.getElementById('os_cyl') || {}).value) || 0,
      axis: parseFloat((document.getElementById('os_axis') || {}).value) || 0,
      add: (document.getElementById('os_add') || {}).value || 'n/a',
    };

    var pdCheckbox = document.getElementById('noSamePd');
    var isSeparate = !!(pdCheckbox && pdCheckbox.checked);
    var pd = isSeparate
      ? {
          left: parseFloat((document.getElementById('od_pd') || {}).value) || 0,
          right: parseFloat((document.getElementById('os_pd') || {}).value) || 0,
        }
      : {
          combined: parseFloat((document.getElementById('pd') || {}).value) || 0,
        };

    var prismCheckbox = document.getElementById('prism');
    var hasPrism = !!(prismCheckbox && prismCheckbox.checked);

    var prism = null;
    if (hasPrism) {
      prism = {
        od: {
          vertical: (document.getElementById('od_prismnum_v') || {}).value || 'n/a',
          vertical_dir: (document.getElementById('od_prismdir_v') || {}).value || 'n/a',
          horizontal: (document.getElementById('od_prismnum_h') || {}).value || 'n/a',
          horizontal_dir: (document.getElementById('od_prismdir_h') || {}).value || 'n/a',
        },
        os: {
          vertical: (document.getElementById('os_prismnum_v') || {}).value || 'n/a',
          vertical_dir: (document.getElementById('os_prismdir_v') || {}).value || 'n/a',
          horizontal: (document.getElementById('os_prismnum_h') || {}).value || 'n/a',
          horizontal_dir: (document.getElementById('os_prismdir_h') || {}).value || 'n/a',
        },
      };
    }

    return {
      person_name: personNameInput ? personNameInput.value : '',
      comments: commentsInput ? commentsInput.value : '',
      od: od,
      os: os,
      pd: pd,
      hasPrism: hasPrism,
      prism: prism,
    };
  }

  function validate(appState) {
    var data = getFormData();
    var errors = [];

    if (!data.person_name || !data.person_name.trim()) {
      errors.push('Please enter a name for this prescription.');
    }

    var hasPd = false;
    if (data.pd) {
      if (data.pd.combined !== undefined && data.pd.combined !== null && data.pd.combined !== '') {
        var combinedNum = parseFloat(data.pd.combined);
        hasPd = !isNaN(combinedNum) && combinedNum > 0;
      }
      if (!hasPd && data.pd.left !== undefined && data.pd.right !== undefined) {
        var leftNum = parseFloat(data.pd.left);
        var rightNum = parseFloat(data.pd.right);
        hasPd = !isNaN(leftNum) && leftNum > 0 && !isNaN(rightNum) && rightNum > 0;
      }
    }
    if (!hasPd) {
      errors.push('Please select a PD value.');
    }

    var manualFormHidden = (function () {
      var el = document.getElementById('prescription-form-container');
      return el && el.classList.contains('hide-prescription');
    })();
    var hasUploadedFile = !!(
      (appState && (appState.rxFileUrl || appState.rxFilePreview)) ||
      (window.lensSelectorApp &&
        (window.lensSelectorApp.uploadedPrescriptionFileBase64 ||
          window.lensSelectorApp.uploadedPrescriptionFileUrl))
    );

    // Upload mode is active when the manual form is hidden.
    // In this mode, a file must actually be uploaded before moving next.
    if (manualFormHidden) {
      if (!hasUploadedFile) {
        errors.push('Please upload your prescription file before continuing.');
      }
    } else {
      var odSph = parseFloat(data.od && data.od.sph) || 0;
      var odCyl = parseFloat(data.od && data.od.cyl) || 0;
      var osSph = parseFloat(data.os && data.os.sph) || 0;
      var osCyl = parseFloat(data.os && data.os.cyl) || 0;
      var hasRxValues = (Math.abs(odSph) > 0 || Math.abs(odCyl) > 0 || Math.abs(osSph) > 0 || Math.abs(osCyl) > 0);
      if (!hasRxValues) {
        errors.push('Please enter at least one prescription value (SPH or CYL) for right or left eye.');
      }
    }

    if (data.hasPrism && data.prism) {
      var p = data.prism;
      var odV = (p.od && p.od.vertical) ? String(p.od.vertical).trim() : 'n/a';
      var osV = (p.os && p.os.vertical) ? String(p.os.vertical).trim() : 'n/a';
      var odVDir = (p.od && p.od.vertical_dir) ? String(p.od.vertical_dir).trim() : 'n/a';
      var osVDir = (p.os && p.os.vertical_dir) ? String(p.os.vertical_dir).trim() : 'n/a';
      var odH = (p.od && p.od.horizontal) ? String(p.od.horizontal).trim() : 'n/a';
      var osH = (p.os && p.os.horizontal) ? String(p.os.horizontal).trim() : 'n/a';
      var odHDir = (p.od && p.od.horizontal_dir) ? String(p.od.horizontal_dir).trim() : 'n/a';
      var osHDir = (p.os && p.os.horizontal_dir) ? String(p.os.horizontal_dir).trim() : 'n/a';

      var hasVerticalPrism = (odV !== '' && odV !== 'n/a') || (osV !== '' && osV !== 'n/a');
      var hasHorizontalPrism = (odH !== '' && odH !== 'n/a') || (osH !== '' && osH !== 'n/a');

      if (!hasVerticalPrism && !hasHorizontalPrism) {
        errors.push('Please enter at least one prism value (either vertical or horizontal).');
      } else {
        if (hasVerticalPrism) {
          if (odV !== '' && odV !== 'n/a' && (odVDir === '' || odVDir === 'n/a')) {
            errors.push('Please select vertical base direction for right eye (OD).');
          }
          if (osV !== '' && osV !== 'n/a' && (osVDir === '' || osVDir === 'n/a')) {
            errors.push('Please select vertical base direction for left eye (OS).');
          }
        }
        if (hasHorizontalPrism) {
          if (odH !== '' && odH !== 'n/a' && (odHDir === '' || odHDir === 'n/a')) {
            errors.push('Please select horizontal base direction for right eye (OD).');
          }
          if (osH !== '' && osH !== 'n/a' && (osHDir === '' || osHDir === 'n/a')) {
            errors.push('Please select horizontal base direction for left eye (OS).');
          }
        }
      }
    }

    return { valid: errors.length === 0, errors: errors };
  }

  function handleCylAxisDependency() {
    var odCyl = document.getElementById('od_cyl');
    var osCyl = document.getElementById('os_cyl');
    var odAxis = document.getElementById('od_axis');
    var osAxis = document.getElementById('os_axis');

    if (odCyl && odAxis) {
      var odVal = parseFloat(odCyl.value) || 0;
      odAxis.disabled = odVal === 0;
      if (odAxis.disabled) odAxis.value = '';
    }
    if (osCyl && osAxis) {
      var osVal = parseFloat(osCyl.value) || 0;
      osAxis.disabled = osVal === 0;
      if (osAxis.disabled) osAxis.value = '';
    }
  }

  function handlePDToggle(isSeparate) {
    var singleEls = document.querySelectorAll('#prescription-form-container .js-pd-add-one, #prescription-form .js-pd-add-one');
    var doubleEls = document.querySelectorAll('#prescription-form-container .js-pd-add-two, #prescription-form .js-pd-add-two');
    singleEls.forEach(function (el) {
      el.style.display = isSeparate ? 'none' : '';
    });
    doubleEls.forEach(function (el) {
      el.style.display = isSeparate ? '' : 'none';
      var select = el.querySelector('select');
      if (select) select.disabled = !isSeparate;
    });
  }

  function handlePrismToggle(hasPrism) {
    var prismContent = document.querySelector('.js-prism-content');
    if (!prismContent) return;
    prismContent.style.display = hasPrism ? 'grid' : 'none';
  }

  function updateRecommendation() {
    var recEl = document.getElementById('lens-recommendation');
    if (!recEl) return;

    var app = window.lensSelectorApp;
    var isUploadFlow =
      app &&
      ((app.state && app.state.rxMethod === 'upload') ||
        !!app.uploadedPrescriptionFileBase64 ||
        (app.state && app.state.rxFileUrl && String(app.state.rxFileUrl).trim()));
    if (isUploadFlow) {
      recEl.textContent = '';
      recEl.style.display = 'none';
      return;
    }

    var data = getFormData();
    var tier = Utils.getRecommendedLensTier(
      data.od.sph, data.od.cyl, data.os.sph, data.os.cyl
    );

    if (tier && tier !== 'basic') {
      var label = tier.charAt(0).toUpperCase() + tier.slice(1);
      recEl.textContent = 'Based on your prescription, we recommend ' + label + ' lenses for the best visual clarity.';
      recEl.style.display = 'block';
    } else {
      recEl.textContent = '';
      recEl.style.display = 'none';
    }
  }

  function init(app) {
    var prismCheckbox = document.getElementById('prism');
    var pdCheckbox = document.getElementById('noSamePd');
    var odCyl = document.getElementById('od_cyl');
    var osCyl = document.getElementById('os_cyl');

    if (prismCheckbox) {
      prismCheckbox.addEventListener('change', function () {
        handlePrismToggle(!!prismCheckbox.checked);
        if (app && typeof app.calculateTotalPrice === 'function') {
          app.calculateTotalPrice();
        }
      });
    }

    if (pdCheckbox) {
      pdCheckbox.addEventListener('change', function () {
        handlePDToggle(!!pdCheckbox.checked);
      });
    }

    if (odCyl) {
      odCyl.addEventListener('change', function () {
        handleCylAxisDependency();
        updateRecommendation();
      });
    }
    if (osCyl) {
      osCyl.addEventListener('change', function () {
        handleCylAxisDependency();
        updateRecommendation();
      });
    }

    var odSph = document.getElementById('od_sph');
    var osSph = document.getElementById('os_sph');
    if (odSph) odSph.addEventListener('change', updateRecommendation);
    if (osSph) osSph.addEventListener('change', updateRecommendation);

    handleCylAxisDependency();
  }

  function prefill(previousRxData) {
    if (!previousRxData) return;
    var nameInput = document.getElementById('person_name');
    var commentsInput = document.getElementById('comments');
    if (nameInput && previousRxData.person_name) nameInput.value = previousRxData.person_name;
    if (commentsInput && previousRxData.comments) commentsInput.value = previousRxData.comments;
  }

  function clearErrors() {}

  window.OletLens.PrescriptionModule = {
    init: init,
    getFormData: getFormData,
    validate: validate,
    prefill: prefill,
    clearErrors: clearErrors,
    handleCylAxisDependency: handleCylAxisDependency,
    handlePDToggle: handlePDToggle,
    handlePrismToggle: handlePrismToggle,
    updateRecommendation: updateRecommendation,
  };
})();
